import { Stack } from 'expo-router'
import { FC } from 'react'

const SettingsLayout: FC = () => {
    return (
        <Stack screenOptions={{ headerShown: false }}>
            <Stack.Screen name="(tabs)" />
        </Stack>
    )
}

export default SettingsLayout
